export default __webpack_public_path__ + "static/bridge-433106a9e93317969ce187b75ed9fbda.webp";